import pdf2md from "@opendocsg/pdf2md"



export const pdfToMarkdown = async (buffer: Buffer): Promise<string> => {
    try {
        const md = pdf2md(buffer).then((markdown: string) => {
            return markdown;
        })
        return md;
    }
    catch (error) {
        console.error("Error converting PDF to Markdown:", error);
        throw error;
    }
}